import { ShieldCheck, Wrench, Package, ClipboardList, MessagesSquare, CalendarClock, HardHat } from "lucide-react";

const MAP = {
  Sécurité: ShieldCheck,
  Outillage: Wrench,
  Matériaux: Package,
  Consignes: ClipboardList,
  Communication: MessagesSquare,
  Planning: CalendarClock,
};

export function ThemeIcon({ theme, className = "w-6 h-6" }) {
  const Icon = MAP[theme] || HardHat;
  return <Icon className={className} />;
}
